import { DigitalSignatureRequestStatuses } from "../../entities/IDigitalSignatureRequest";
import { MetaDataForm } from "../../entities/IMetaData";
import { GenericForm } from "../generic-form/GenericForm.types";
import { useTranslation } from "react-i18next";
import { useToast } from "../toast";
import { useState, useEffect, useRef } from "react";

const OMIT_KEYS = ["sendEmailToCustomer"];

export const useViewDigitalSignatureModal = (
  fields: GenericForm<MetaDataForm> | null,
  isVisible: boolean
) => {
  const [hasChanged, setHasChanged] = useState(false);
  // Store initial values as a ref so it stays stable
  const initialValuesRef = useRef<Record<string, any>>({});

  // Track current form values in state
  const [currentValues, setCurrentValues] = useState<Record<string, any>>({});

  const showDeleteOption =
    fields?.status?.defaultValue !==
    DigitalSignatureRequestStatuses.SIGNED.charAt(0).toUpperCase() +
      DigitalSignatureRequestStatuses.SIGNED.slice(1);

  const { success } = useToast();
  const { t } = useTranslation();

  const normalize = (key: string, value: any) => {
    if (key === "authorizedSignatory") {
      return value ?? 0;
    }
    return value;
  };

  const onValueChange = (key: string, value: any) => {
    setCurrentValues((prev) => {
      const updated = { ...prev, [key]: normalize(key, value) };

      // Compare all keys with initialValuesRef
      const changed = Object.keys(initialValuesRef.current).some((k) => {
        if (OMIT_KEYS.includes(k)) return false;
        return initialValuesRef.current[k] !== updated[k];
      });

      setHasChanged(changed);

      return updated;
    });
  };

  useEffect(() => {
    if (fields && !isVisible) {
      const initialValues: Record<string, any> = {};
      Object.keys(fields).forEach((key) => {
        initialValues[key] = fields[key].defaultValue;
      });
      initialValuesRef.current = initialValues;
      setCurrentValues(initialValues);
      setHasChanged(false);
    }
  }, [fields, isVisible]);

  return {
    t,
    showDeleteOption,
    hasChanged,
    onValueChange,
  };
};
